import React from 'react';
import SunEditor from 'suneditor-react';
import 'suneditor/dist/css/suneditor.min.css';

export default function LayoutEditorPage(){
    const [contents, setContents] = React.useState("");

    const handleChangeContent = setContents;

    return <div>

        <SunEditor
            height={"400px"}
            onChange={(content) => handleChangeContent(content)}
            setContents={contents} 
        />

    </div>
}